import React, { useState } from 'react'
import CreatorCommonModel from '../../Common/CreatorCommonModel'
import { RiDeleteBin5Line } from "react-icons/ri";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { BuyPackageAction } from '../../../Redux/Actions/CreatorBuyPackageAction';
import { ScrollPanel } from 'primereact/scrollpanel';
import { FaQuestion } from "react-icons/fa6";

const RowBuy = ({ curElem }) => {
    // navigation('/amountpage', { state: { "payment_id": res.data.payment_id } })
    const navigation = useNavigate()
    const dispatch = useDispatch()
    const [loader, setLoader] = useState({
        save: false
    })
    const [show, setShow] = useState(false)
    const handleClose = () => setShow(false)
    const handleBuy = () => {
        setLoader({
            ...loader,
            save: true
        })
        let data = {
            id: curElem.id
        }
        dispatch(BuyPackageAction("buy-package", data, navigation, setLoader, loader, handleClose))
    }
    return (
        <>
            <div className='col-lg-6 col-md-6 col-xl-3'>
                <div className='submission_wrap hover-submission submission_bg align-items-center p-4 px-3 mb-4'>
                    <div className='d-flex flex-column custom-border gap-3 align-items-center'>
                        <h6 className='p-0 plans-user' style={{ fontWeight: "600", color: "#f10065", fontSize: "16px" }}>{curElem.name}</h6>
                        <h3 className='p-0' style={{ fontSize: "35px", fontWeight: "700" }}>${curElem.resellerprice}</h3>
                        <div className='d-flex align-items-center gap-1'>
                            <p className='my-0 py-0 px-0'>Credits:</p><h6 style={{ fontSize: "15px" }}> {curElem.credit}</h6>
                        </div>
                    </div>
                    <ScrollPanel className='mt-1 mb-4' style={{ width: '100%', height: '250px' }}>
                        <p className='' dangerouslySetInnerHTML={{ __html: curElem.description }} />
                    </ScrollPanel>

                    <div style={{ fontSize: "15px", width: "fit-content" }} className='theme-btn' type="button" onClick={() => setShow(true)} >Buy Now</div>
                </div>
            </div>
            <CreatorCommonModel show={show} handleClose={handleClose} handleReject={handleBuy} loader={loader} icons={<FaQuestion style={{ fontSize: "30px", color: "#d92d20" }} />} text="Are you sure you want to buy  package?" />
        </>
    )
}
export default RowBuy